<template>
  <v-container>
    <v-navigation-drawer
      v-model="drawerRight"
      app
      clipped
      right
      width="350"
      class="pa-6"
    ></v-navigation-drawer>
    <h2>User Analytics</h2>
    <v-row>
      <v-col md="6">
        <v-select
          :items="users"
          label="User ID"
          outlined
          v-model="selected_id"
          v-on:change="onSelectUser"
        ></v-select>
      </v-col>
    </v-row>
    <div>Name: {{ user_details.full_name }}</div>
    <div>Group: {{ user_details.group_id }}</div>
    <v-row>
      <v-col md="2" v-for="date in FR_dates" v-bind:key="date.id">
        <v-card @click="getFRdata(date.id)">
          <v-card-subtitle>{{ date.id }}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <div v-show="show_details">
      <v-row>
        <v-col md="4" v-for="data in FR_data" v-bind:key='data.id'>
          <v-card></v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import firebase from "firebase";
import ENV from './../../store/modules/environtment'

export default {
  name: "UserAnalytics",
  data() {
    return {
      users: [],
      selected_id: null,
      selected_date: null,
      user_details: {},
      FR_dates: [],
      FR_data: [],
      drawerRight: false,
      show_details: false
    };
  },
  methods: {
    onSelectUser() {
      firebase
        .firestore()
        .collection(ENV.firebase.userAnalytic)
        .doc(this.selected_id)
        .get()
        .then(doc => {
          this.user_details = doc.data();
          this.getFR();
        });
    },
    getFR() {
      firebase
        .firestore()
        .collection(ENV.firebase.userAnalytic)
        .doc(this.selected_id)
        .collection(ENV.firebase.faceRecognition)
        .get()
        .then(doc => {
          this.FR_dates = doc.docs;
          // doc.docs.forEach(row => {
          //   this.FR_dates.push(row.id);
          // });
        });
    },
    getFRdata(selected_date) {
      this.show_details = true;
      firebase
        .firestore()
        .collection(ENV.firebase.userAnalytic)
        .doc(this.selected_id)
        .collection(ENV.firebase.faceRecognition)
        .doc(selected_date)
        .get()
        .then(doc => {
          this.FR_data = doc.data();
        });
    },
    getUsers() {
      this.users = [];
      firebase
        .firestore()
        .collection(ENV.firebase.userAnalytic)
        .get()
        .then(doc => {
          doc.docs.forEach(row => {
            this.users.push(row.id);
          });
        });
    }
  },
  created() {
    this.getUsers();
  }
};
</script>
